import { render, staticRenderFns } from "./RocketIcon.vue?vue&type=template&id=2765b1ff&"
import script from "./RocketIcon.vue?vue&type=script&lang=ts&"
export * from "./RocketIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports